module.exports = __webpack_public_path__ + "static/P2-57d419c99de7b434c73313410769e3df.pdf";